// Note: this is a magic list of subdomains that we know are asset URLs

const LIST_OF_ASSET_SUBDOMAINS: string[] = [
  `assets`,
  `picture`,
  `preview`,
  `stream`,
];

/**
 * @desc Check if the given URL is an asset URL
 */
const isAssetUrl = (url: string, list = LIST_OF_ASSET_SUBDOMAINS) =>
  list.some((str) => url.includes(str));

export default isAssetUrl;
